import React from "react";

function CryptoIndustry() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Crypto Gaming Industry Insight</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  The crypto gaming industry is rapidly transforming traditional
                  gaming by integrating blockchain technology, creating new
                  opportunities for players and developers alike. With the
                  market expected to reach over $65 billion by 2027,
                  play-to-earn models and NFTs are leading the way, allowing
                  players to own, trade, and earn real value from in-game
                  assets. In 2023 alone, blockchain games accounted for nearly
                  50% of all blockchain activity, attracting millions of users
                  worldwide. This shift toward decentralized ownership and
                  monetization is driving massive growth, positioning crypto
                  gaming as a major force in the digital economy.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default CryptoIndustry;
